import { Injectable } from '@angular/core';
import { HttpClient, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class AuthenService {

  constructor(private http: HttpClient) { }

  path = environment.apiUrl
  auth_data = JSON.parse(localStorage.getItem("access_token"));

  Login(Username: string, Password: string): Observable<any> {
    let URL = this.path + 'api/Login/Auth';

    let body = {
      Username: Username,
      Password: Password
    }
    return this.http.post(URL, body);
  }

  GetUsersAll(): Observable<any> {

    let URL = this.path + 'api/Users/GetUsersAll';

    // const headers = new HttpHeaders({
    //   'Content-Type': 'application/json',
    //   'Authorization': "Bearer " + this.auth_data['token']
    // })

    // return this.http.get(URL, { headers: headers });
    return this.http.get(URL);
  }

  GetUsersOne(userid: string): Observable<any> {

    let URL = this.path + 'api/Users/GetUsersOne/' + userid;

    // const headers = new HttpHeaders({
    //   'Content-Type': 'application/json',
    //   'Authorization': "Bearer " + localStorage.getItem("access_token")
    // })
    // return this.http.get(URL, { headers: headers });
    return this.http.get(URL);
  }

  AddUsers(
    username: string,
    password: string,
    titleName: string,
    fName: string,
    lName: string,
    email: string,
    role: string,
    tel: string,
    createBy: string,
    updateBy: string
  ): Observable<any> {

    let URL = this.path + 'api/Users/AddUsers';

    let body = {
      username: username,
      password: password,
      role: role,
      createBy: createBy,
      updateBy: updateBy,
      status: "y",
      email: email,
      tel: tel,
      titleName: titleName,
      fName: fName,
      lName: lName
    }

    // const headers = new HttpHeaders({
    //   'Content-Type': 'application/json',
    //   'Authorization': "Bearer " + localStorage.getItem("access_token")
    // })

    // return this.http.post(URL, body, { headers: headers });
    return this.http.post(URL, body);
  }

  UpdateUsers(
    username: string,
    password: string,
    titleName: string,
    fName: string,
    lName: string,
    email: string,
    role: string,
    tel: string,
    updateBy: string,
    userid: string
  ): Observable<any> {

    let URL = this.path + 'api/Users/UpdateUsers/';

    let body = {
      id: userid,
      username: username,
      password: password,
      role: role,
      updateBy: updateBy,
      email: email,
      tel: tel,
      titleName: titleName,
      fName: fName,
      lName: lName
    }

    // const headers = new HttpHeaders({
    //   'Content-Type': 'application/json',
    //   'Authorization': "Bearer " + localStorage.getItem("access_token")
    // })

    // return this.http.post(URL, body, { headers: headers });
    return this.http.post(URL, body);
  }

  // DeleteUsers(id: string): Observable<any> {

  //   let URL = this.path + 'api/Users/DeleteUsers';

  //   let body = {
  //     id: id
  //   }

  //   return this.http.delete(URL, body);
  // }

  Get_user_khet(): Observable<any> {

    let URL = this.path + 'api/Users/GetKhet';

    // const headers = new HttpHeaders({
    //   'Content-Type': 'application/json',
    //   'Authorization': "Bearer " + localStorage.getItem("access_token")
    // })
    // return this.http.get(URL, { headers: headers });
    return this.http.get(URL);
  }

  Get_user_Province(): Observable<any> {

    let URL = this.path + 'api/Users/GetProvince';

    // const headers = new HttpHeaders({
    //   'Content-Type': 'application/json',
    //   'Authorization': "Bearer " + localStorage.getItem("access_token")
    // })
    // return this.http.get(URL, { headers: headers });
    return this.http.get(URL);
  }

  Get_manage_role(role: string): Observable<any> {

    let URL = this.path + 'api/Users/GetManageRole/' + role;

    // const headers = new HttpHeaders({
    //   'Content-Type': 'application/json',
    //   'Authorization': "Bearer " + localStorage.getItem("access_token")
    // })
    // return this.http.get(URL, { headers: headers });
    return this.http.get(URL);
  }

  Add_edit_manage_role(arr_body: any, role: string): Observable<any> {

    let URL = this.path + 'api/Users/AddManageRole/' + role;


    // const headers = new HttpHeaders({
    //   'Content-Type': 'application/json',
    //   'Authorization': "Bearer " + localStorage.getItem("access_token")
    // })

    // return this.http.post(URL, body, { headers: headers });
    return this.http.post(URL, arr_body);
  }

  Add_mapping_user(arr_body: any, idUser: any): Observable<any> {

    idUser = +idUser;
    let URL = this.path + 'api/Users/AddMappingUser/' + idUser;


    // const headers = new HttpHeaders({
    //   'Content-Type': 'application/json',
    //   'Authorization': "Bearer " + localStorage.getItem("access_token")
    // })

    // return this.http.post(URL, body, { headers: headers });
    return this.http.post(URL, arr_body);
  }

  Get_mapping_user(idUser: string): Observable<any> {

    let URL = this.path + 'api/Users/GetMappingUser/' + idUser;

    // const headers = new HttpHeaders({
    //   'Content-Type': 'application/json',
    //   'Authorization': "Bearer " + localStorage.getItem("access_token")
    // })
    // return this.http.get(URL, { headers: headers });
    return this.http.get(URL);
  }

  sent_email(
    username: string,
    password: string,
    email: string
  ): Observable<any> {

    let URL = this.path + 'api/Login/EmailSend';

    // const headers = new HttpHeaders({
    //   'Content-Type': 'application/json',
    //   'Authorization': "Bearer " + localStorage.getItem("access_token")
    // })
    // return this.http.get(URL, { headers: headers });

    let body = {
      username: username,
      password: password,
      email: email
    }
    return this.http.post(URL, body);
  }

  Get_user_center(): Observable<any> {

    let URL = this.path + 'api/Users/GetCenterAgency';

    // const headers = new HttpHeaders({
    //   'Content-Type': 'application/json',
    //   'Authorization': "Bearer " + localStorage.getItem("access_token")
    // })
    // return this.http.get(URL, { headers: headers });
    return this.http.get(URL);
  }

  GetProvinceByUserid(id: any): Observable<any> {

    let URL = this.path + 'api/Login/GetProvinceByUserid/' + id;

    // const headers = new HttpHeaders({
    //   'Content-Type': 'application/json',
    //   'Authorization': "Bearer " + localStorage.getItem("access_token")
    // })
    // return this.http.get(URL, { headers: headers });
    return this.http.get(URL);
  }

}
